import { createContext, useContext } from 'react';

/**
 * Provides the currently loaded customer profile to any screen that needs it,
 * eliminating the need to thread loadedProfileData through every render call.
 *
 * Value shape: { loadedProfileData, setLoadedProfileData }
 */
export const ProfileContext = createContext(null);
export const useProfile = () => useContext(ProfileContext);
